import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getPersona, setPersona as setPersonaApi, switchPersona as switchPersonaApi } from "../api/smb.api";

const PersonaContext = createContext();

export const PersonaProvider = ({ children }) => {
  const [persona, setPersona] = useState(null);
  const [personas, setPersonas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchPersona = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setIsLoading(false);
        return;
      }
      const result = await getPersona();
      if (result?.status && result?.data) {
        setPersona(result.data.primary);
        setPersonas(result.data.personas || []);
      }
    } catch (err) {
      console.log("PersonaContext fetch error:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPersona();
  }, [fetchPersona]);

  const initPersona = useCallback(async (personaType) => {
    try {
      const result = await setPersonaApi(personaType);
      if (result?.status && result?.data) {
        setPersona(result.data);
        await fetchPersona();
      }
      return result;
    } catch (err) {
      console.error("Set persona error:", err);
    }
  }, [fetchPersona]);

  const doSwitchPersona = useCallback(async (personaType) => {
    try {
      const result = await switchPersonaApi(personaType);
      if (result?.status && result?.data) {
        setPersona(result.data);
        await fetchPersona();
      }
      return result;
    } catch (err) {
      console.error("Switch persona error:", err);
    }
  }, [fetchPersona]);

  return (
    <PersonaContext.Provider
      value={{
        persona,
        personas,
        isLoading,
        initPersona,
        switchPersona: doSwitchPersona,
        refreshPersona: fetchPersona,
      }}
    >
      {children}
    </PersonaContext.Provider>
  );
};

export const usePersona = () => useContext(PersonaContext);
export default PersonaContext;
